import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { CouponItemType } from '../../@types/coupon';
import { getSubmitCoupons } from '../../api/coupons';
import { fadeIn, fadeOut } from '../../js/animation';
import { plusComma } from '../../js/script';

interface PropsType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  orderSheetNo: number;
  setTitle: any;
  setCartCoupon: any;
  cartCoupon: any;
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function OrderCartCouponCenterModal({
  setIsModal,
  orderSheetNo,
  setTitle,
  setCartCoupon,
  cartCoupon,
}: PropsType) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요
  const [item, setItem] = useState<CouponItemType[]>([]);
  const [cartCouponCopy, setCartCouponCopy] = useState<any>(null);

  const closeModal = () => {
    setClosing(true);
    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  useEffect(() => {
    const copy = cartCoupon;
    setCartCouponCopy(copy);
  }, [cartCoupon]);

  useEffect(() => {
    getSubmitCoupons(orderSheetNo)
      .then((res) => {
        setItem(res.data.cartCoupons);
      })
      .catch((err) => console.log(err));
  }, []);

  // if (!isModal) return null;
  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p
            style={{
              fontSize: '20px',
              lineHeight: '24px',
              fontWeight: isMobile ? '500' : '600',
            }}
          >
            사용 가능 쿠폰
            <span
              style={{
                display: 'inline-block',
                color: 'var(--colPointBlue)',
                marginLeft: '4px',
              }}
            >
              {item?.length}
            </span>
          </p>
          <button
            onClick={closeModal}
            style={{
              border: '0',
              padding: '0',
              margin: '0',
              background: 'transparent',
              width: '48px',
              height: '48px',
              position: 'absolute',
              top: '6px',
              right: '4px',
            }}
          >
            <img src="../images/icon_close_btn.png" alt="" style={{ width: '100%' }} />
          </button>
        </ModalHeader>
        <ModalBody>
          <CouponBox>
            {item?.map((el: any, idx: number) => {
              return (
                <CouponItem key={idx}>
                  <input
                    type="radio"
                    id={`coupon${idx}`}
                    style={{
                      border: '0',
                      padding: '0',
                      fontSize: '0',
                      lineHeight: 'inherit',
                      color: 'transparent',
                      letterSpacing: '0',
                      margin: '0',
                      display: 'none',
                    }}
                    onChange={(e) => {
                      setTitle(`${el.couponName} ${plusComma(el.couponDiscountAmt)}원 할인 `);
                      setCartCouponCopy(Number(el.couponIssueNo));
                    }}
                    name="coupon_radio"
                  />
                  <label
                    htmlFor={`coupon${idx}`}
                    style={{
                      padding: '20px',
                      border:
                        Number(cartCouponCopy) === Number(el?.couponIssueNo)
                          ? '1px solid var(--colPointBlue)'
                          : '1px solid var(--colGray3)',
                      borderRadius: '6px',
                      display: 'block',
                    }}
                  >
                    <div>
                      <p
                        style={{
                          fontSize: '15px',
                          lineHeight: '20px',
                          color: 'var(--colBlack)',
                        }}
                      >
                        {el.couponName}
                      </p>
                      <span
                        style={{
                          fontSize: '12px',
                          lineHeight: '15px',
                          color: 'var(--colGray6)',
                          display: 'block',
                          marginTop: '4px',
                        }}
                      >
                        {`최대 ${
                          el.maxDiscountAmt ? plusComma(el.maxDiscountAmt) : plusComma(el.couponDiscountAmt)
                        }원 할인`}
                      </span>
                      <strong
                        style={{
                          fontSize: '24px',
                          lineHeight: '26px',
                          color: 'var(--colPointBlue)',
                          display: 'block',
                          marginTop: '8px',
                        }}
                      >
                        {plusComma(el.couponDiscountAmt)}원
                      </strong>
                    </div>
                  </label>
                </CouponItem>
              );
            })}
          </CouponBox>
        </ModalBody>
        <ModalFooter>
          <div
            onClick={() => {
              setCartCouponCopy(null);
              closeModal();
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              border: '1px solid var(--colGray3)',
              fontSize: '14px',
              lineHeight: '46px',
            }}
          >
            취소
          </div>

          <div
            style={{
              width: '100%',
              textAlign: 'center',
              borderRadius: '5px',
              background: 'var(--colBlack)',
              color: 'var(--colWhite)',
              fontSize: '14px',
              lineHeight: '48px',
            }}
            onClick={() => {
              setCartCoupon(cartCouponCopy);
              closeModal();
            }}
          >
            확인
          </div>
        </ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  z-index: 900;
`;

export const ModalBox = styled.div<typeProps>`
  width: 480px;
  background-color: var(--colWhite);
  border-radius: 10px;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 18px 20px;
  align-items: center;
  position: relative;
`;

export const ModalBody = styled.div``;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  margin: 0 20px;
`;

export const CouponBox = styled.div`
  display: flex;
  margin: 8px 20px;
  flex-direction: column;
  gap: 12px;
  max-height: 328px;
  min-height: 129px;
  overflow-y: auto;
`;

export const CouponItem = styled.div``;
